import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-default-codebook-list',
	templateUrl: './default-codebook-list.component.html',
	styleUrls: ['./default-codebook-list.component.css'],
})
export class DefaultCodebookListComponent extends ListComponent {
	protected apiUrl = '';
	protected apiType = 'bag';
	kind = '';
	codebooks = [];
	selectedCodebook;
	title: string;
	tableRows = [{ id: 'name', name: 'Nazwa' }];

	filters = {
		limit: 9999,
	};

	protected loadBefore() {
		this.kind = this.route.snapshot.params['kind'];
		switch (this.kind) {
			case 'organization_role':
				this.apiUrl = 'organization/role';
				break;
			case 'departments_kind':
				this.apiUrl = 'organization/department_kind';
				break;
			case 'service_type':
				this.apiUrl = 'offer/service_type';
				break;
			default:
				this.apiUrl = this.kind;
		}
		this.bag.get('/codebook/?limit=9999', (result, error) => {
			this.codebooks = result.results;
			this.selectedCodebook = this.codebooks.find((item) => item.url == this.route.snapshot.url[1].path);
			this.title = `Słowniki -> ${this.selectedCodebook.name}`;
			this.loadData();
		});
	}
}
